import { useTheme } from "./useTheme.ts";
import type { Density } from "../providers/themeProvider.tsx";

/** Thin wrapper around useTheme that exposes only the density pair. */
export function useDensity(): { density: Density; setDensity: (d: Density) => void } {
  const { density, setDensity } = useTheme();
  return { density, setDensity };
}
